import { render, staticRenderFns } from "./sugiCard.vue?vue&type=template&id=ef5a7794&scoped=true"
import script from "./sugiCard.vue?vue&type=script&lang=js"
export * from "./sugiCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef5a7794",
  null
  
)

export default component.exports